import request from '@/utils/request'

//帆软入口
export function queryReportMessage (data) {
  return request({
    url: `/web/mdReport/queryReportMessage`,
    method: 'post',
    data
  });
}
//帆软服务器登录
export function queryReportLoginUrl (loginUrl) {
  return request({
    url: loginUrl,
    dataType: 'jsonp',
    jsonpCallback: "success_jsonpCallback",
    method: 'get'
  });
}
export function queryMdReportTemplate (data) {
  return request({
    url: `/common/cts-manager/custom-api/CTS_ILP_MdReportTemplate/common/CTS_ILP_MdReportTemplate`,
    method: 'post',
    data
  });
}

